import type { RichTextCustomElement } from '../../../types.js'

export const li: RichTextCustomElement = {
  name: 'li',
  Element: '@payloadcms/richtext-slate/client#ListItemElement',
}
